import type { PartSvgProps } from './types'

export default function AkMagBananaSvg545 ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 56,
  height = 88
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 56 88" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Feed lips */}
      <rect x="10" y="2" width="36" height="8" rx="2" fill={stroke} />
      {/* Banana body — 5.45x39: shallower curve than 7.62 variant */}
      <path d="M 14,10 C 11,35 6,62 7,78 L 40,78 C 48,62 50,35 42,10 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Horizontal ribs */}
      <line x1="13" y1="32" x2="45" y2="32" stroke={stroke} strokeWidth="0.8" strokeOpacity="0.5" />
      <line x1="8" y1="53" x2="44" y2="53" stroke={stroke} strokeWidth="0.8" strokeOpacity="0.5" />
      <line x1="7" y1="70" x2="39" y2="70" stroke={stroke} strokeWidth="0.8" strokeOpacity="0.5" />
      {/* Base plate */}
      <rect x="5" y="75" width="37" height="8" rx="2" fill={stroke} />
    </svg>
  )
}
